import { dsColorNew } from "@palette"

// Selected treatment shared by every toggle of the wizard: the app's pill toggle
// (`@components/@base/ToggleButton`) on a plain MUI ToggleButtonGroup — a grey track, and the
// chosen option in soft blue with an app-blue edge. The edge is on every option (transparent when
// off) so selecting one doesn't shift the others by a pixel.
export const dsRepricingToggleSx = {
	gap: '4px',
	p: '3px',
	borderRadius: '10px',
	backgroundColor: dsColorNew.pillTrackBg,
	border: `1px solid ${dsColorNew.grayBorder}`,
	'& .MuiToggleButton-root': {
		m: 0,
		border: '1.5px solid transparent !important',
		borderRadius: '8px !important',
		px: '14px',
		py: '6px',
		textTransform: 'none',
		fontSize: 13,
		fontWeight: 500,
		lineHeight: 1.2,
		whiteSpace: 'nowrap',
		color: dsColorNew.textMuted,
		'&:hover': { backgroundColor: dsColorNew.white },
		'&.Mui-selected, &.Mui-selected:hover': {
			color: dsColorNew.appBlue,
			fontWeight: 600,
			backgroundColor: dsColorNew.pillActiveBg,
			borderColor: `${dsColorNew.appBlue} !important`,
		},
	},
}

export default dsRepricingToggleSx
